let collectionListMediaQuery = window.matchMedia('(max-width: 749px)');
if (collectionListMediaQuery.matches) {
    const collectionsMobileList = document.querySelector('.collection_list_mobile_slider');
    if (collectionsMobileList) {
        const collection_mobile_list = new Flickity(collectionsMobileList, {
            autoPlay: false,
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            contain: true,
            // cellAlign: 'left',
            imagesLoaded: true,
            arrowShape: {
                prev: '.carousel-prev svg',
                next: '.carousel-next svg'
            },
            responsive: [{
                breakpoint: 768,
                settings: {
                    prevNextButtons: false,
                    wrapAround: true
                }
            }]
        });
        document.querySelector('.carousel-prev').addEventListener('click', function() {
            collection_mobile_list.previous();
        });
        document.querySelector('.carousel-next').addEventListener('click', function() {
            collection_mobile_list.next();
        }); 
        // Get the collection handle from the URL 
        const url = new URL(window.location.href);
        const segments = url.pathname.split('/');
        const collectionHandle = segments[segments.indexOf('collections') + 1]; 
        
        // Find all elements with the data-handle attribute 
        const collectionItems = document.querySelectorAll('[data-handle]'); 
        
        // Loop through each item to check if it matches the collection handle 
        collectionItems.forEach((item) => {
            if (item.getAttribute('data-handle') === collectionHandle) {
                collection_mobile_list.selectCell(item);
                item.classList.add('selected'); // Add 'selected' class
            }
        });
    }
} else {
    const collectionsList = document.querySelector('.collection-custom-slider');
    if (collectionsList) {
        const collections_List = new Flickity(collectionsList, {
            autoPlay: false,
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            contain: true,
            cellAlign: 'left',
            imagesLoaded: true,
            arrowShape: {
                prev: '.carousel-prev svg',
                next: '.carousel-next svg'
            },
            responsive: [{
                breakpoint: 768,
                settings: {
                    prevNextButtons: false,
                    wrapAround: false
                }
            }]
        });
        document.querySelector('.carousel-prev').addEventListener('click', function() {
            collections_List.previous();
        });
        document.querySelector('.carousel-next').addEventListener('click', function() {
            collections_List.next();
        }); 
        // Get the collection handle from the URL 
        const url = new URL(window.location.href);
        const segments = url.pathname.split('/');
        const collectionHandle = segments[segments.indexOf('collections') + 1]; 
      
        // Find all elements with the data-handle attribute 
        const collectionItems = document.querySelectorAll('[data-handle]'); 
      
        // Loop through each item to check if it matches the collection handle 
        collectionItems.forEach((item) => {
            if (item.getAttribute('data-handle') === collectionHandle) {
                collections_List.selectCell(item);
                item.classList.add('selected'); // Add 'selected' class 
            }
        });
    }
}
const url = new URL(window.location.href);
const segments = url.pathname.split('/');
const collectionHandle = segments[segments.indexOf('collections') + 1]; 

// Find all elements with the data-handle attribute 
const collectionItems = document.querySelectorAll('[data-handle]'); 

// Loop through each item to check if it matches the collection handle 
collectionItems.forEach((item) => {
    if (item.getAttribute('data-handle') === collectionHandle) {
        item.classList.add('selected'); // Add 'selected' class 
    }
});